import stateClasses from '../data/stateClasses';

export default function init() {
	const navigation = document.querySelector('.js-primary-nav');
	const subNavs = document.querySelectorAll('.js-sub-nav');
	const dropdownButtons = navigation.querySelectorAll('.js-menu-item-dropdown-button');
	const parentMenuItems = navigation.querySelectorAll('.js-parent-menu-item');
	const navToggle = document.querySelector('.js-nav-toggle');

	navToggle.addEventListener('click', () => {
		document.body.classList.toggle(stateClasses.isNavOpen);
	});

	// prevent clicks in sub navs propagating up to the parent nav
	subNavs.forEach(subNav => {
		subNav.addEventListener('click', e => e.stopPropagation());
	});

	navigation.addEventListener('click', e => {
		
		// if we haven't clicked a parent item, just carry on
		const menuItem = e.target.closest('.js-parent-menu-item');
		if (!menuItem) {
			return;
		}

		e.preventDefault();

		// if it's already open, close it
		if (menuItem.classList.contains(stateClasses.isOpen)) {
			menuItem.classList.remove(stateClasses.isOpen);
			return;
		}

		// close all open subnavs
		parentMenuItems.forEach(menuItem => menuItem.classList.remove(stateClasses.isOpen));

		// open this subnav
		menuItem.classList.toggle(stateClasses.isOpen);
	});
}